"use client";

import type { Dispatch, Reducer } from "react";
import { createContext, useContext, useReducer } from "react";
import { FilterTypes, GlobalFilterActionTypes } from "@/constants/Constants";
type FilterState = {
  selectedFilter: string | null;
  filterOptions: string[];
};
type State = {
  [filterName: string]: FilterState;
};
type Action = {
  type: GlobalFilterActionTypes.SET_FILTER_OPTIONS;
  filter: string;
  options: string[];
} | {
  type: GlobalFilterActionTypes.SELECT_FILTER;
  filter: string;
  selectedFilter: string | null;
};
const initialState: State = {
  global: {
    selectedFilter: null,
    filterOptions: [FilterTypes.Labs, FilterTypes.Orders, FilterTypes.Patients, FilterTypes.Tests, FilterTypes.Panels]
  }
};
export const StateContext = createContext<State | null>(null);
export const DispatchContext = createContext<Dispatch<Action> | null>(null);
function reducer(state: State, action: Action): State {
  switch (action.type) {
    case GlobalFilterActionTypes.SET_FILTER_OPTIONS:
      return {
        ...state,
        [action.filter]: {
          ...state[action.filter],
          filterOptions: action.options,
          selectedFilter: state[action.filter]?.selectedFilter ?? null
        }
      };
    case GlobalFilterActionTypes.SELECT_FILTER:
      return {
        ...state,
        [action.filter]: {
          ...state[action.filter],
          selectedFilter: action.selectedFilter ?? null,
          filterOptions: state[action.filter]?.filterOptions ?? []
        }
      };
    default:
      return state;
  }
}
export function GlobalFilterProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [state, dispatch] = useReducer<Reducer<State, Action>>(reducer, initialState);
  return <StateContext.Provider value={state}>
      <DispatchContext.Provider value={dispatch}>
        {children}
      </DispatchContext.Provider>
    </StateContext.Provider>;
}
export function useStateContext() {
  const context = useContext(StateContext);
  if (!context) {
    throw new Error("useStateContext must be used within a GlobalFilterProvider");
  }
  return context;
}
export function useDispatchContext() {
  const context = useContext(DispatchContext);
  if (!context) {
    throw new Error("useDispatchContext must be used within a GlobalFilterProvider");
  }
  return context;
}